import { RightsApi } from '@app/services/rights-service/rights-service';
import { enqueSnackAction } from '@app/store/snacks';
import { call, put, take } from 'redux-saga/effects';
import {
  fetchValueRightsAction,
  forceSaveValueRightsAction,
  setValueRightsDataAction,
  setValueRightsLoadingAction,
  updateValueRightsAction,
} from '../actions';

export function* forceSaveValueRightsSaga(
  action: ReturnType<typeof forceSaveValueRightsAction>
) {
  try {
    yield put(setValueRightsLoadingAction({ loading: true }));
    const updateItems = action.items;

    const dto = Object.keys(updateItems).map((i) => {
      const currentManager = updateItems[i].managers.find(
        (f) => f.isPrimaryProductOwner === true
      );
      return {
        productGroupId: i,
        userId: currentManager?.id as string,
        isPrimaryLabelProductOwner: currentManager?.isPrimaryProductOwner,
      };
    });
    yield call(RightsApi.updateValueRights, {
      data: dto,
    });
    yield put(fetchValueRightsAction({}));
    yield take(setValueRightsDataAction.TYPE);
    yield put(updateValueRightsAction({ items: {} }));

    yield put(
      enqueSnackAction({
        notification: {
          message: 'Rights sucessfully updated for selected group.',
          options: {
            variant: 'success',
          },
          key: 'value-rights-save',
        },
      })
    );
  } catch (e) {
    console.log('Failed to set rights', e.message);
    if (
      e.response &&
      (e.response.status === 409 || e.response.status === 400)
    ) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'value-rights-save',
          },
        })
      );
    }

    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'value-rights-save',
        },
      })
    );
  } finally {
    yield put(setValueRightsLoadingAction({ loading: false }));
  }
}
